// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IwRW","name":"styles_name__2JQJG","phone":"styles_phone__vhQdv"};